import React, { memo } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlaneDeparture,
  faPlaneArrival,
} from "@fortawesome/free-solid-svg-icons";

function DayCell({
  cellKey,
  dayNum,
  dateStr,
  disabled,
  isArrival,
  isDeparture,
  isBetween,
  isSelectedMonthDay,
  isMonthMode,
  isAgentAppearance,
  hasPrice,
  priceRounded,
  toneCls,
  priceLinePrefix,
  onSelect,
}) {
  const showEndpointChrome =
    isAgentAppearance && (isArrival || isDeparture);

  return (
    <div
      data-day-key={cellKey}
      role={disabled || isMonthMode ? undefined : "button"}
      aria-label={
        isArrival
          ? `יציאה ${dateStr}`
          : isDeparture
            ? `חזרה ${dateStr}`
            : undefined
      }
      className={classNames("drp-day", {
        "drp-day-selected": isArrival || isDeparture,
        "drp-day-selected-start": isArrival,
        "drp-day-selected-end": isDeparture,
        "drp-day-between": isBetween,
        "drp-day-disabled": disabled,
        "drp-day-with-price": hasPrice && !disabled,
        "drp-day-in-selected-month": isSelectedMonthDay,
      })}
      onClick={
        disabled || isMonthMode ? undefined : () => onSelect(dateStr)
      }
    >
      {showEndpointChrome ? (
        <>
          <FontAwesomeIcon
            icon={isDeparture ? faPlaneArrival : faPlaneDeparture}
            className="drp-endpoint-plane-icon drp-day-plane-icon"
            aria-hidden
          />
          <span className="drp-day-num">{dayNum}</span>
          <span className="drp-day-role">{isArrival ? "יציאה" : "חזרה"}</span>
          <span className="drp-day-date-full">{dateStr}</span>
        </>
      ) : (
        <>
          <span className="drp-day-num">{dayNum}</span>
          {hasPrice && !disabled ? (
            <span className={classNames("drp-day-price", toneCls)}>
              {priceLinePrefix ? (
                <>
                  <span className="drp-day-price-prefix">{priceLinePrefix}</span>
                  {priceRounded.toLocaleString()} ₪
                </>
              ) : (
                <>{priceRounded.toLocaleString()} ₪</>
              )}
            </span>
          ) : null}
        </>
      )}
    </div>
  );
}

export default memo(DayCell);
